define('views/shop/search/search',[
	'views/_base/baseview',
	'text!views/shop/search/search.html',
	'models/shared/lookups/lookups',
	'models/validator/zipcode',
	'models/search/search_suggestion_collection',
	'models/search/location_suggestion_collection',
], function (
	BaseView,
	Template,
	LookupsModel,
	ZipcodeValidator,
	MerchantSuggestionsModel,
	LocationSuggestionsModel
) {
	'use strict';

	return BaseView.extend({
		className: 'merchant-search-container',
		tagName: 'div',
		isRender: true,

		// Events
		events: {
			'submit, click': 'stopLoadSearch',
		},

		// Templates
		template: _.template(Template),

		// General Configurations
		focused: null, // BOOLEAN : Controls the overall page and component display
		type: 1, // ENUM/INT: Control which view is displayed, nearby vs. online (refers to enums.merchantLocationTypes; nearby is default)
		query: null, // STRING  : Query either picked from suggestions or passed down from the URL
		page_size: 40, // INT     : How many results per page
		sort_pref: null, // INT     : User's preference for sorting results
		category_preference: null, // INT     : User's preference for category filter
		zipcode: null, // STRING  : Zip code used for local merchant search
		nearby_loaded: false, // BOOLEAN : For checks on whether nearby has been added to the dom
		online_loaded: false,
		input_blur_delay: 700,
		location_preference: 1, // ENUM/INT: merchantLocationPreference - Current: 1, Search: 2, Zipcode: 3

		// OBJECT: General incomplete online merchant search object structure
		online_data: {
			c: null,
			start: 0,
			loctypeids: '[4]',
		},

		// OBJECT: General incomplete nearby merchant search object structure
		nearby_data: {
			c: null,
			start: 0,
			agids: '[0,1,2,4,5]',
			loctypeids: '[1]',
		},

		initialize: function (options) {
			options = options || {};

			// Make options available to entire view
			this.options = options.options ? options.options : {};

			this.shop = options.shop ? options.shop : {};

			this.online = options.online;

			this.online_config = {};

			this.online_config.categories = pf.getContent(
				'shop.config.online.categories'
			);

			this.nearby_config = {};

			this.nearby_config.categories = pf.getContent(
				'shop.config.nearby.categories'
			);

			// Sync all presets before we Render or Load
			this.syncPresets();

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		syncPresets: function () {
			// Sync the following presets: Merchant Type, Merchant Category, Merchant Location, Merchant Query, Current Position, Zipcode

			// Check to see if the type exists within the URL
			if (this.options.type) {
				this.type = this.options.type;
			}

			// Set the default zipcode
			this.setZip();

			// Define the last defualts for Nearby search data
			this.nearby_data.c = this.page_size;

			// Define the last defualts for Online search data
			this.online_data.c = this.page_size;

			// If logged in, append the user guid for online queries only so that the affiliate url comes with it
			if (pf.session.get('auth')) {
				this.online_data.userguid = pf.session.get('UserGUID');
			}

			// Get the Nearby categories in advance
			this.getCategoryOptions();
		},

		render: function () {
			var that = this;

			this.prepareSearchData();

			this.$el.html(this.template());

			// TODO: Add this to the events config options
			this.$('.js-merchant-search-btn-only').on('click', function () {
				that.openMerchantMobileSearchForm();
			});

			// this.$('.js-merchant-search-clear-icon').on('click', function(){
			//     that.handleMerchantSearchClear();
			// });

			return this;
		},

		prepareSearchData: function () {
			// Reset the start if re-rendering the shop page
			if (this.nearby_data.start) {
				this.nearby_data.start = 0;
			}

			if (this.online_data.start) {
				this.online_data.start = 0;
			}
		},

		stopLoadSearch: function () {
			console.log('%cSTOP LOAD - SEARCH', 'color: rebeccapurple');
			return false;
		},

		getCategoryOptions: function () {
			this.categories = new LookupsModel();

			this.categories.fetch({
				url: pf.lookupsURL + '/MerchantFilterCategories',
				async: false,
				success: function () {},
			});
		},

		setCategoryPreference: function (preference) {
			if (
				preference == undefined ||
				preference == 'null' ||
				preference == null
			) {
				preference = null;
			} else {
				preference = parseInt(preference);
			}

			pf.session.setMerchantCategoryPref(preference);

			this.category_preference = preference;
		},

		loadData: function () {
			var that = this;

			// Get the location preference
			if (this.getLocationPreference()) {
				this.location_preference = this.getLocationPreference();
			}

			// If neither have loaded get location then adjust the elements before getting merchants
			if (!this.online_loaded && !this.nearby_loaded) {
				if (
					this.location_preference == enums.merchantLocationPreference.Search
				) {
					if (this.online) {
						var merchant_name = pf.session.getOnlineLocalQuery();
					} else {
						var merchant_name = pf.session.getLocalQuery();
					}

					this.updateMerchantSearchInput(merchant_name);

					// Update the location input field
					this.updateLocationSearchInput();

					// Update the location input
					this.addLocationToNearbySearchData();

					// Make sure the correct elements are showing
					this.shop.handleShopViewToggle();
				} else {
					// Get the current location
					this.getCurrentLocation(function (current_location) {
						if (current_location) {
							that.setLocationSearchName('Current Location');
						} else {
							that.setLocationSearchName(that.zipcode);
						}

						// Update the location input field
						that.updateLocationSearchInput();

						// Make sure the correct elements are showing
						that.shop.handleShopViewToggle();
					});
				}
			} else {
				if (this.online) {
					// Get Online Merchants
					this.shop.getOnlineMerchants();
				} else {
					// Get the current location
					this.getCurrentLocation(function (current_location) {
						if (current_location) {
							that.setLocationSearchName('Current Location');
						} else {
							that.setLocationSearchName(that.zipcode);
						}

						// Update the location input field
						that.updateLocationSearchInput();

						// Get Nearby Merchants
						that.shop.getNearbyMerchants();
					});
				}
			}
		},

		getCurrentLocation: function (callback) {
			var that = this;

			// Temporary so we don't have to deal with the built in navigator
			// that.setZip();
			// that.addCurrentLocationToNearbySearchData();

			navigator.geolocation.getCurrentPosition(
				function (position) {
					that.setLocationPreference(1);

					// Add the current location to the search data
					that.addCurrentLocationToNearbySearchData(position);

					if (_.isFunction(callback)) {
						callback(true);
					}
				},
				function (a) {
					that.setLocationPreference(3);

					// Since current location isn't available, set the zipcode
					that.setZip();

					// Add the zipcode to the search data
					that.addCurrentLocationToNearbySearchData();

					if (_.isFunction(callback)) {
						callback(false);
					}
				}
			);
		},

		addLocationToNearbySearchData: function () {
			var position = this.getLocationSearchPosition(),
				name = this.getLocationSearchName();

			// Update the location search name
			this.updateLocationSearchInput(name);
			// Update the location search data
			this.nearby_data.loc = '[' + position + ']';
			this.online_data.loc = '[' + position + ']';
		},

		addCurrentLocationToNearbySearchData: function (position) {
			if (position) {
				this.nearby_data.loc =
					'[' +
					position.coords.latitude +
					',' +
					position.coords.longitude +
					']';
				this.online_data.loc =
					'[' +
					position.coords.latitude +
					',' +
					position.coords.longitude +
					']';
			} else {
				this.nearby_data.zip = this.zipcode;
				this.online_data.zip = this.zipcode;
			}
		},

		/*
            Shop Event Functions
        */

		loadMoreMerchants: function () {
			if (this.type == enums.merchantLocationTypes.Online) {
				this.online_data.start =
					Number(this.online_data.start) + Number(this.online_data.c);

				this.shop.getOnlineMerchants();
			} else if (this.type == enums.merchantLocationTypes.Store) {
				this.nearby_data.start =
					Number(this.nearby_data.start) + Number(this.nearby_data.c);

				// Get Nearby Merchants
				this.shop.getNearbyMerchants(true);
			}
		},

		/*
            Shop Search Functions
        */

		handleMerchantSearchForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			// console.log('handleMerchantSearchForm',this.nearby_data,this.merchant_search_query,this.merchant_search_query_id, this.location_search_position, this.location_search_name, this.zipcode);

			// Factors
			// this.nearby_data,
			// this.merchant_search_query,
			// this.merchant_search_query_id,
			// this.location_search_position,
			// this.location_search_name,
			// this.zipcode

			/*
                Merchant Search Reference Notes

                1) If nothing was touched/changed and submit is pressed then nearby_data should remain unchanged

                    1.1) Suggested Logic - If "merchant_search_query_id" and "location_search_position" are empty or match the data within "nearby_data.mgguid" and "nearby_data.loc", then do nothing

                2) If Merchants search is a partial search with suggestions, use the first suggestion

                    2.1) Suggested Logic - Check the "merchant_search_query_id" to see if it exists and or matches the "nearby_data.mgguid".  If it does not then use "merchant_search_query_id" and if it is different it implies that a new successful suggestion or suggestion selection was made, therefore we want to use the most up-to-date.

                3) If Location search is a partial search with suggestions, use the first suggestion

                    3.1) Suggested Logic - Check the "location_search_position" to see if it exists and or matches the "nearby_data.loc".  If it does not then use "location_search_position" and if it is different it implies that a new successful suggestion or suggestion selection was made, therefore we want to use the most up-to-date

            */

			// Reference #1
			// if(!this.merchant_search_query_id && !this.location_search_position || this.merchant_search_query_id == this.nearby_data.mgguid && this.location_search_position == this.nearby_data.loc){
			//     return false;
			// } else {

			// }

			// Clear any deeplink merchant searches by nulling merchant_guid
			this.clearDeeplink();

			// console.log('shop search',this.merchant_search_query_id,this.nearby_data.mgguid);

			if (this.online) {
				var request_data = this.online_data;
			} else {
				var request_data = this.nearby_data;
			}

			// Reference #2
			if (
				this.merchant_search_query_id ||
				this.merchant_online_search_query_id
			) {
				// console.log('inside reference #2',this.merchant_search_query_id != this.nearby_data.mgguid);

				if (this.online) {
					request_data.mgguid = this.merchant_online_search_query_id;

					// Update the merchant search input and placeholder
					this.updateMerchantSearchInput(this.merchant_online_search_query);
				} else {
					request_data.mgguid = this.merchant_search_query_id;

					// Update the merchant search input and placeholder
					this.updateMerchantSearchInput(this.merchant_search_query);
				}

				// User may still be in focus of the field
				this.$('.js-merchant-search-input').blur();
			} else if (
				this.merchant_search_query ||
				this.merchant_online_search_query
			) {
				if (this.online) {
					request_data.q = this.merchant_online_search_query;

					// Update the merchant search input and placeholder
					this.updateMerchantSearchInput(this.merchant_online_search_query);
				} else {
					request_data.q = this.merchant_search_query;

					// Update the merchant search input and placeholder
					this.updateMerchantSearchInput(this.merchant_search_query);
				}

				// User may still be in focus of the field
				this.$('.js-merchant-search-input').blur();
			}

			// console.log('handleMerchantSearchForm Reference #3',this.nearby_data.loc,this.location_search_position, this.location_search_position != this.nearby_data.loc);

			// Reference #3
			if (
				this.location_search_position &&
				this.location_search_position != this.nearby_data.loc
			) {
				request_data.loc = '[' + this.location_search_position + ']';
			}

			if (this.location_search_position && this.location_search_name) {
				// Update the location search input and placeholder
				this.$('.js-merchant-location-search-input').val('');
				this.$('.js-merchant-location-search-input').attr(
					'placeholder',
					this.location_search_name
				);

				// User may still be in focus of the field
				this.$('.js-merchant-location-search-input').blur();
			}

			request_data.start = 0;

			if (this.online) {
				// Get Online Merchants
				this.shop.getOnlineMerchants();
			} else {
				// Remove Nearby merchants
				this.shop.removeNearbyMerchants();

				// Perform Search
				this.shop.getNearbyMerchants();
			}
		},

		updateMerchantSearchInput: function (merchant) {
			// Update the merchant search input and placeholder
			this.$('.js-merchant-search-input').val('');
			this.$('.js-merchant-search-input').attr('placeholder', merchant);

			// Update the merchant mobile search input and placeholder
			this.$('.js-merchant-mobile-search-input').val('');
			this.$('.js-merchant-mobile-search-input').attr('placeholder', merchant);

			this.$('.js-merchant-search-btn-only').html(
				enums.svg.merchantSearchIcon + ' ' + merchant
			);
		},

		/*
            --> Merchant Search
        */

		getMerchantSearchClassNames: function (is_mobile) {
			var suggestions_handle = is_mobile
					? 'js-merchant-mobile-search-suggestions'
					: 'js-merchant-search-suggestions',
				suggestion_classname = is_mobile
					? 'merchant-mobile-query-suggestion'
					: 'merchant-query-suggestion';

			return {
				handle: suggestions_handle,
				classname: suggestion_classname,
			};
		},

		getMerchantLocationSearchClassNames: function (is_mobile) {
			var suggestions_handle = is_mobile
					? 'js-merchant-mobile-search-suggestions'
					: 'js-merchant-location-suggestions',
				suggestion_classname = is_mobile
					? 'merchant-mobile-location-suggestion'
					: 'merchant-location-suggestion';

			return {
				handle: suggestions_handle,
				classname: suggestion_classname,
				current_location: 'current-location',
			};
		},

		handleMerchantSearchFocus: function (e) {
			var that = this;

			this.$('.js-merchant-search-form').addClass('merchant-query-focus');
			this.$('.js-merchant-search-suggestions').fadeIn();

			if (
				!this.focused &&
				this.$('#shop-instore-preview-container').is(':visible')
			) {
				this.$('#shop-instore-preview-container').hide();
			} else if (
				!this.focused &&
				this.$('#shop-online-preview-container').is(':visible')
			) {
				this.$('#shop-online-preview-container').hide();
			}

			if (
				(this.online && this.online_config.categories) ||
				(!this.online && this.nearby_config.categories)
			) {
				this.addCategoryOptions();
			}

			if (!this.online) {
				if (!this.shop.map_container) {
					this.shop.addMap();
				} else {
					setTimeout(function () {
						google.maps.event.trigger(pf.maps.current, 'resize');

						that.shop.map_container.resetBounds();
					}, 1000);
				}
			}
		},

		handleMerchantSearchBlur: function (e) {
			var that = this;

			setTimeout(function () {
				that.$('.js-merchant-search-form').removeClass('merchant-query-focus');
				that.$('.js-merchant-search-suggestions').fadeOut();
			}, this.input_blur_delay);
		},

		handleMerchantSearchKeyup: function (e, is_mobile) {
			var merchant_name = $(e.target).val();

			if (this.online) {
				// Update session and nearby view
				this.setOnlineQuery(merchant_name);

				// Reset search query id
				this.merchant_online_search_query_id = null;
				pf.session.setOnlineQueryId(null);

				// Delete the Merchant GUID if there is one
				if (this.online_data.mgguid) {
					delete this.online_data.mgguid;
				}

				// Delete the Merchant GUID if there is one
				if (this.online_data.catids) {
					delete this.online_data.catids;
				}
			} else {
				// Update session and nearby view
				this.setQuery(merchant_name);

				// Reset search query id
				this.merchant_search_query_id = null;
				pf.session.setQueryId(null);

				// Delete the Merchant GUID if there is one
				if (this.nearby_data.mgguid) {
					delete this.nearby_data.mgguid;
				}

				// Delete the Merchant GUID if there is one
				if (this.nearby_data.catids) {
					delete this.nearby_data.catids;
				}
			}

			this.getMerchantSuggestions(merchant_name, is_mobile);
		},

		getMerchantSuggestions: function (merchant_name, is_mobile) {
			var that = this,
				suggestions = this.getMerchantSearchClassNames(is_mobile);

			this.merchant_search_suggestions = new MerchantSuggestionsModel({
				instanceURL: pf.searchSuggestionURL,
				pageSize: 20,
			});

			this.merchant_search_suggestions
				.fetch({
					type: 'GET',
					contentType: 'application/json',
					data: {
						q: merchant_name,
						loctypeids: this.online ? '[4]' : '[1]',
					},
				})
				.done(function () {
					var merchant_suggestions = '';

					if (that.merchant_search_suggestions.length) {
						that.merchant_search_suggestions.forEach(function (el, count) {
							var merchant = el.attributes;

							if (merchant.SuggestionName) {
								// if(count == 0){
								//     that.updateMerchantSearchQuery(el, is_mobile);
								// }

								merchant_suggestions +=
									'<li><a href="#" class="' +
									suggestions.classname +
									'" data-id="' +
									merchant.GUID +
									'">' +
									merchant.SuggestionName +
									'</a></li>';
							}
						}, this);

						that.$('.' + suggestions.handle).html(merchant_suggestions);

						that
							.$('.' + suggestions.handle)
							.find('.' + suggestions.classname)
							.on('click', function (e) {
								if (e && e.preventDefault) {
									e.preventDefault();
								}
								if (e && e.stopPropagation) {
									e.stopPropagation();
								}

								that.updateMerchantSearchQuery($(e.target), is_mobile);
							});
					} else {
						// TODO: Show no results message
					}
				});
		},

		updateMerchantSearchQuery: function (merchant, is_mobile) {
			var is_html = merchant.attributes ? false : true,
				merchant = merchant.attributes ? merchant.attributes : merchant,
				id = is_html ? merchant.data('id') : merchant.GUID,
				name = is_html ? merchant.html() : merchant.SuggestionName;

			// Clear any deeplink merchant searches by nulling merchant_guid
			this.clearDeeplink();

			// Update session and nearby view
			this.setQuery(name);

			this.setQueryId(id);

			if (this.online) {
				this.online_data.mgguid = id;
				this.online_data.start = 0;

				// Delete the categories if there are any
				if (this.online_data.catids) {
					delete this.online_data.catids;
				}

				// Delete query so that it doesn't confilct with Merchant GUID
				if (this.online_data.q) {
					delete this.online_data.q;
				}
			} else {
				// Update nearby search data
				this.nearby_data.mgguid = id;
				this.nearby_data.start = 0;

				// Delete the categories if there are any
				if (this.nearby_data.catids) {
					delete this.nearby_data.catids;
				}

				// Delete query so that it doesn't confilct with Merchant GUID
				if (this.nearby_data.q) {
					delete this.nearby_data.q;
				}
			}

			if (is_html) {
				// Update the search inputs
				this.updateMerchantSearchInput(name);

				if (is_mobile) {
					this.closeMerchantMobileSearchForm();
				}

				if (this.online) {
					this.shop.getOnlineMerchants();
				} else {
					// Remove Nearby merchants
					this.shop.removeNearbyMerchants();

					// Perform Search
					this.shop.getNearbyMerchants();
				}
			}
		},

		setQuery: function (name) {
			if (!name) {
				// Get previously searched query
				if (pf.session.getLocalQuery()) {
					name = pf.session.getLocalQuery();
				}
			}

			this.merchant_search_query = name;
			pf.session.setLocalQuery(name);
		},

		setQueryId: function (id) {
			if (!id) {
				// Get previously searched query
				if (pf.session.getQueryId()) {
					id = pf.session.getQueryId();
				}
			}
			this.merchant_search_query_id = id;
			pf.session.setQueryId(id);
		},

		setOnlineQuery: function (name) {
			if (!name) {
				// Get previously searched query
				if (pf.session.getOnlineLocalQuery()) {
					name = pf.session.getOnlineLocalQuery();
				}
			}

			this.merchant_online_search_query = name;
			pf.session.setOnlineLocalQuery(name);
		},

		setOnlineQueryId: function (id) {
			if (!id) {
				// Get previously searched query
				if (pf.session.getOnlineQueryId()) {
					id = pf.session.getOnlineQueryId();
				}
			}
			this.merchant_online_search_query_id = id;
			pf.session.setOnlineQueryId(id);
		},

		handleMerchantSearchClear: function (e) {
			// Clear merchant search input and add categories to search suggestions
			this.updateMerchantSearchInput('Search Merchants');

			if (this.online) {
				delete this.online_data.catids;
				delete this.online_data.mgguid;
				delete this.online_data.q;

				this.merchant_online_search_query_id = null;

				this.merchant_online_search_query = null;

				// Update online search data as well
				this.online_data.start = 0;

				// Update online search page size count
				this.online_data.c = this.page_size;
			} else {
				// Delete the categories and merchant guid if there are any
				delete this.nearby_data.catids;
				delete this.nearby_data.mgguid;
				delete this.nearby_data.q;

				this.merchant_search_query_id = null;

				this.merchant_search_query = null;

				// Update Nearby search data as well
				this.nearby_data.start = 0;

				// Update Nearby search page size count
				this.nearby_data.c = this.page_size;
			}

			if (
				(this.online && this.online_config.categories) ||
				(!this.online && this.nearby_config.categories)
			) {
				// Add categories as default merchant suggestion state
				this.addCategoryOptions();
			}
		},

		addCategoryOptions: function (is_mobile) {
			var that = this,
				suggestions = this.getMerchantSearchClassNames(is_mobile);

			this.$('.' + suggestions.handle).html('');

			this.categories.each(function (category) {
				that
					.$('.' + suggestions.handle)
					.append(
						'<li><a href="#" class="' +
							suggestions.classname +
							'" data-id="' +
							category.ID +
							'">' +
							category.Name +
							'</a></li>'
					);
			});

			this.$('.' + suggestions.handle)
				.find('.' + suggestions.classname)
				.on('click', function (e) {
					if (e && e.preventDefault) {
						e.preventDefault();
					}
					if (e && e.stopPropagation) {
						e.stopPropagation();
					}

					that.updateCategory($(e.target), is_mobile);
				});
		},

		updateCategory: function (category, is_mobile) {
			var id = category.data('id'),
				name = category.html();

			// Update session and nearby view
			this.setCategoryPreference(id);

			if (this.online) {
				// Update nearby search data
				this.online_data.catids = '[' + id + ']';
				this.online_data.start = 0;

				// Delete the merchant guid if there are any
				if (this.online_data.mgguid) {
					delete this.online_data.mgguid;
				}

				// Delete the merchant query if there are any
				if (this.online_data.q) {
					delete this.online_data.q;
				}

				// Nullify these two so that if user does a general search it won't override the category search
				this.merchant_online_search_query = null;
				this.merchant_online_search_query_id = null;
			} else {
				// Update nearby search data
				this.nearby_data.catids = '[' + id + ']';
				this.nearby_data.start = 0;

				// Delete the merchant guid if there are any
				if (this.nearby_data.mgguid) {
					delete this.nearby_data.mgguid;
				}

				// Delete the merchant query if there are any
				if (this.nearby_data.q) {
					delete this.nearby_data.q;
				}

				// Nullify these two so that if user does a general search it won't override the category search
				this.merchant_search_query = null;
				this.merchant_search_query_id = null;
			}

			// Update the merchant search input and placeholder
			this.$('.js-merchant-search-input').val('');
			this.$('.js-merchant-search-input').attr('placeholder', name);

			// Update the merchant mobile search input and placeholder
			this.$('.js-merchant-mobile-search-input').val('');
			this.$('.js-merchant-mobile-search-input').attr('placeholder', name);

			this.$('.js-merchant-search-btn-only').html(
				enums.svg.merchantSearchIcon + ' ' + name
			);

			if (is_mobile) {
				this.closeMerchantMobileSearchForm();
			}

			if (this.online) {
				this.shop.getOnlineMerchants();
			} else {
				// Remove Nearby merchants
				this.shop.removeNearbyMerchants();

				// Perform Search
				this.shop.getNearbyMerchants();
			}
		},

		/*
            --> Merchant Mobile Search
        */

		submitMerchantMobileSearchForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			this.closeMerchantMobileSearchForm();

			this.handleMerchantSearchForm();
		},

		openMerchantMobileSearchForm: function () {
			this.shop.showFullMerchantViewSearch();

			$('#header-container').css({ 'z-index': '1' });

			this.$('.js-merchant-mobile-search-form-container').fadeIn();
			this.$('.js-merchant-mobile-search-input').focus();
			this.$('.js-merchant-mobile-search-form').addClass(
				'merchant-mobile-query-focus'
			);

			if (this.online) {
				this.$('.js-merchant-mobile-location-search-input').hide();
				this.$('.merchant-mobile-location-icon').hide();
			} else {
				this.$('.js-merchant-mobile-location-search-input').show();
				this.$('.merchant-mobile-location-icon').show();
			}
		},

		closeMerchantMobileSearchForm: function () {
			this.$('.js-merchant-mobile-search-form-container').fadeOut(function () {
				$('#header-container').css({ 'z-index': '100' });
			});
		},

		handleMerchantMobileSearchFocus: function (e) {
			this.$('.js-merchant-mobile-search-form').addClass(
				'merchant-mobile-query-focus'
			);
			this.$('.js-merchant-mobile-search-suggestions').fadeIn();

			if (
				(this.online && this.online_config.categories) ||
				(!this.online && this.nearby_config.categories)
			) {
				this.addCategoryOptions(true);
			}
		},

		handleMerchantMobileSearchBlur: function (e) {
			var that = this;

			setTimeout(function () {
				that
					.$('.js-merchant-mobile-search-form')
					.removeClass('merchant-mobile-query-focus');
				// that.$('.js-merchant-mobile-search-suggestions').fadeOut();
			}, this.input_blur_delay);
		},

		handleMerchantMobileSearchKeyup: function (e) {
			this.handleMerchantSearchKeyup(e, true);
		},

		handleMerchantMobileSearchClear: function () {
			this.$('.js-merchant-mobile-search-input').val('');
			this.$('.js-merchant-mobile-search-form').addClass(
				'merchant-mobile-query-focus'
			);
		},

		/*
            --> Merchant Mobile Location Search
        */

		handleLocationMobileSearchFocus: function (e) {
			this.$('.js-merchant-mobile-search-form').addClass(
				'merchant-mobile-location-focus'
			);
			this.$('.js-merchant-mobile-search-suggestions').fadeIn();

			this.addCurrentLocationOption(true);
		},

		handleLocationMobileSearchBlur: function (e) {
			var that = this;

			setTimeout(function () {
				that
					.$('.js-merchant-mobile-search-form')
					.removeClass('merchant-mobile-location-focus');
				// that.$('.js-merchant-location-suggestions').fadeOut();
			}, this.input_blur_delay);
		},

		handleLocationMobileSearchClear: function (e) {
			this.handleLocationSearchClear(e, true);
		},

		handleLocationMobileSearchKeyup: function (e) {
			var location_name = $(e.target).val();

			this.getLocationSuggestions(location_name, true);
		},

		/*
            --> Location Search
        */

		handleLocationSearchFocus: function (e) {
			var that = this;

			this.$('.merchant-search-form').addClass('merchant-location-focus');
			this.$('.js-merchant-location-suggestions').fadeIn();

			if (
				!this.focused &&
				this.$('#shop-instore-preview-container').is(':visible')
			) {
				this.$('#shop-instore-preview-container').hide();
			} else if (
				!this.focused &&
				this.$('#shop-online-preview-container').is(':visible')
			) {
				this.$('#shop-online-preview-container').hide();
			}

			this.addCurrentLocationOption();

			if (!this.shop.map_container) {
				this.shop.addMap();
			} else {
				setTimeout(function () {
					google.maps.event.trigger(pf.maps.current, 'resize');

					that.shop.map_container.resetBounds();
				}, 1000);
			}
		},

		handleLocationSearchBlur: function (e) {
			var that = this;

			setTimeout(function () {
				that.$('.merchant-search-form').removeClass('merchant-location-focus');
				that.$('.js-merchant-location-suggestions').fadeOut();
			}, this.input_blur_delay);
		},

		handleLocationSearchKeyup: function (e) {
			var location_name = $(e.target).val();

			this.getLocationSuggestions(location_name);
		},

		getLocationSuggestions: function (location_name, is_mobile) {
			var that = this,
				suggestions = this.getMerchantLocationSearchClassNames(is_mobile);

			this.location_suggestions = new LocationSuggestionsModel({
				instanceURL: pf.searchCitySuggestionURL,
				pageSize: 20,
			});

			this.location_suggestions
				.fetch({
					type: 'GET',
					contentType: 'application/json',
					data: {
						q: location_name,
					},
				})
				.done(function () {
					var location_suggestions_html =
						'<li><a href="#" class="' +
						suggestions.classname +
						' js-' +
						suggestions.classname +
						' ' +
						suggestions.current_location +
						'">' +
						enums.svg.nearMeIcon +
						' Current Location</a></li>';

					if (that.location_suggestions.length) {
						that.location_suggestions.forEach(function (el, count) {
							var location = el.attributes,
								location_id = location.SuggestionName
									? location.SuggestionName.replace(',', '')
											.split(' ')
											.join('-')
									: null;

							if (location.SuggestionName) {
								if (count == 0) {
									that.updateLocationSearchQuery(location);
								}

								location_suggestions_html +=
									'<li><a href="#" class="' +
									suggestions.classname +
									' js-' +
									suggestions.classname +
									'" data-position="' +
									location.GUID.toString() +
									'" data-zip="' +
									location.SuggestionField1 +
									'">' +
									location.SuggestionName +
									'</a></li>';
							}
						}, this);

						that.$('.' + suggestions.handle).html(location_suggestions_html);

						that
							.$('.' + suggestions.handle)
							.find('.js-' + suggestions.classname)
							.on('click', function (e) {
								if (e && e.preventDefault) {
									e.preventDefault();
								}
								if (e && e.stopPropagation) {
									e.stopPropagation();
								}

								if (!$(e.target).hasClass(suggestions.current_location)) {
									that.updateLocationSearchQuery($(e.target), is_mobile);
								}
							});

						that
							.$('.' + suggestions.handle)
							.find('.' + suggestions.current_location)
							.on('click', function (e) {
								if (e && e.preventDefault) {
									e.preventDefault();
								}
								if (e && e.stopPropagation) {
									e.stopPropagation();
								}

								that.updateLocation();
							});
					} else {
						// TODO: Show no results message
					}
				});
		},

		updateLocationSearchQuery: function (location, is_mobile) {
			var user_initiated = location.GUID ? false : true,
				location = location.GUID ? location : location,
				position = user_initiated
					? location.data('position')
					: location.GUID.toString(),
				zipcode = user_initiated
					? location.data('zip')
					: location.SuggestionField1,
				name = user_initiated ? location.html() : location.SuggestionName;

			// Update session and nearby view
			this.setLocationSearchPosition(position);
			this.setLocationSearchName(name);
			this.setZip(zipcode);

			this.setLocationPreference(2);

			// Update nearby search data location
			this.nearby_data.loc = '[' + position + ']';
			this.online_data.loc = '[' + position + ']';

			if (this.nearby_data.zip) {
				// Delete the zipcode if there are any
				delete this.nearby_data.zip;
			}

			if (user_initiated) {
				// Update the location search input and placeholder
				this.$('.js-merchant-location-search-input').val('');
				this.$('.js-merchant-location-search-input').attr('placeholder', name);

				// Update the location search input and placeholder
				this.$('.js-merchant-mobile-location-search-input').val('');
				this.$('.js-merchant-mobile-location-search-input').attr(
					'placeholder',
					name
				);

				if (is_mobile) {
					this.closeMerchantMobileSearchForm();
				}

				// Remove Nearby merchants
				this.shop.removeNearbyMerchants();

				// Perform Search
				this.shop.getNearbyMerchants();
			}
		},

		getLocationSearchPosition: function (position) {
			return pf.session.getLocationSearchPosition();
		},

		setLocationSearchPosition: function (position) {
			if (!position) {
				// Get previously searched query
				if (pf.session.getLocationSearchPosition()) {
					position = pf.session.getLocationSearchPosition();
				}
			}
			this.location_search_position = position;
			pf.session.setLocationSearchPosition(position);
		},

		getLocationSearchName: function (name) {
			return pf.session.getLocationSearchName();
		},

		setLocationSearchName: function (name) {
			if (!name) {
				// Get previously searched query
				if (pf.session.getLocationSearchName()) {
					name = pf.session.getLocationSearchName();
				}
			}
			this.location_search_name = name;
			pf.session.setLocationSearchName(name);
		},

		handleLocationSearchClear: function (e, is_mobile) {
			// Clear merchant search input and add current location to search suggestions
			this.$('.js-merchant-location-search-input').val('');
			this.$('.js-merchant-location-search-input').attr(
				'placeholder',
				'City or ZIP'
			);

			this.$('.js-merchant-mobile-location-search-input').val('');
			this.$('.js-merchant-mobile-location-search-input').attr(
				'placeholder',
				'City or ZIP'
			);

			// Delete the location and merchant guid if there are any
			delete this.nearby_data.loc;
			delete this.nearby_data.zip;

			delete this.online_data.loc;
			delete this.online_data.zip;

			// Update Nearby search data as well
			this.nearby_data.start = 0;

			// Add location as default merchant suggestion state
			this.addCurrentLocationOption(is_mobile);

			this.updateLocation();
		},

		addCurrentLocationOption: function (is_mobile) {
			var that = this,
				suggestions = this.getMerchantLocationSearchClassNames(is_mobile);

			this.$('.' + suggestions.handle).html('');
			this.$('.' + suggestions.handle).append(
				'<li><a href="#" class="' +
					suggestions.classname +
					' js-' +
					suggestions.classname +
					' ' +
					suggestions.current_location +
					'">' +
					enums.svg.nearMeIcon +
					' Current Location</a></li>'
			);

			this.$('.' + suggestions.handle)
				.find(
					'.js-' + suggestions.classname + '.' + suggestions.current_location
				)
				.on('click', function (e) {
					if (e && e.preventDefault) {
						e.preventDefault();
					}
					if (e && e.stopPropagation) {
						e.stopPropagation();
					}

					that.updateLocation();
				});
		},

		updateLocation: function () {
			var that = this;

			this.getCurrentLocation(function (current_location) {
				if (current_location) {
					that.setLocationSearchName('Current Location');
				} else {
					that.setLocationSearchName(that.zipcode);
				}

				that.updateLocationSearchInput();

				that.shop.getNearbyMerchants();
			});
		},

		updateLocationSearchInput: function () {
			var name = this.getLocationSearchName(),
				location = name ? name : this.zipcode;

			this.$('.js-merchant-location-search-input').val('');
			this.$('.js-merchant-location-search-input').attr(
				'placeholder',
				location
			);

			this.$('.js-merchant-mobile-location-search-input').val('');
			this.$('.js-merchant-mobile-location-search-input').attr(
				'placeholder',
				location
			);
		},

		/*
            Shop Utility Functions
        */

		getCurrentPosition: function () {
			return pf.session.getCurrentPosition();
		},

		setCurrentPosition: function (position) {
			if (!position) {
				// Get previous position
				if (pf.session.getCurrentPosition()) {
					position = pf.session.getCurrentPosition();
				}
			}

			this.current_location = position;
			pf.session.setCurrentPosition(position);
		},

		zipIsValid: function (zip) {
			var validator = new ZipcodeValidator();
			validator.validate(zip);
			return validator.isValid();
		},

		setZip: function (zip) {
			if (!zip) {
				if (pf.session.getLocalZipCode()) {
					// Previously searched zip
					zip = pf.session.getLocalZipCode();
				} else if (pf.session.get('ZipCode')) {
					// Registered zip
					zip = pf.session.get('ZipCode');
				} else if (pf.session.getISPZip()) {
					// Not accurate ISP based zip
					zip = pf.session.getISPZip();
				} else {
					// Santa Clarita, CA
					zip = '91355';
				}
			}

			this.zipcode = zip;
		},

		getLocationPreference: function () {
			return pf.session.getLocationPreference();
		},

		setLocationPreference: function (preference) {
			if (!preference) {
				// Get previous position
				if (pf.session.getLocationPreference()) {
					preference = pf.session.getLocationPreference();
				}
			}

			this.location_preference = preference;
			pf.session.setLocationPreference(preference);
		},

		clearDeeplink: function () {
			// Clear any deeplink merchant searches by nulling merchant_guid
			if (this.options.merchant_guid) {
				this.options.merchant_guid = null;
			}
		},

		close: function () {
			// console.log('closing shop view',this.focused);
		},
	});
});

